<wsd-extended-card
  [loading]="!(goodStanding$ | async)"
  [title]="'DATA_PORTAL.GOOD_STANDING.TITLE' | translate">

  <div *ngIf="goodStanding$ | async as data">

    <div class="text-center primary-color">
      <i class="fa status fa-check-circle"></i>
    </div>

    <div class="text-center m-t-15">
      <span class="numbers primary-color">
        {{ data.count + '/' + data.total  }}
      </span>
    </div>

  </div>
</wsd-extended-card>
